import { render, staticRenderFns } from "./aspectoCorreos.vue?vue&type=template&id=11d0d880&scoped=true&"
import script from "./aspectoCorreos.vue?vue&type=script&lang=js&"
export * from "./aspectoCorreos.vue?vue&type=script&lang=js&"
import style0 from "./aspectoCorreos.vue?vue&type=style&index=0&id=11d0d880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0d880",
  null
  
)

export default component.exports